module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    attrs: {
      "id": "OldFlames_epub-6.html",
      "xml:lang": "en-US"
    }
  }, [_c('div', {
    staticClass: "story"
  }, [_c('p', {
    staticClass: "CT-new-page para-style-override-11"
  }, [_c('span', {
    staticClass: "Section-Symbol char-style-override-16"
  }, [_vm._v("‘")]), _c('span', {
    staticClass: "char-style-override-16"
  }, [_vm._v(". . . SIS would not merely defend the traditional decencies of our society: it would embody them. Within its own walls, its clubs and country houses, in whispered luncheons, with its secular contacts, it would enshrine the mystical entity of a vanishing England. Here at least, whatever went on in the big world outside, England’s flower would be cherished. “The Empire may be crumbling; but within our secret elite, the clean-limbed tradition of English power would survive. We believe in nothing but ourselves”.’")])]), _vm._v(" "), _c('p', {
    staticClass: "BT para-style-override-7"
  }, [_c('span', {
    staticClass: "char-style-override-17"
  }, [_vm._v("John le Carré")])]), _vm._v(" "), _c('p', {
    staticClass: "EPI-note para-style-override-7"
  }, [_vm._v("(from his introduction to "), _c('span', {
    staticClass: "char-style-override-2"
  }, [_vm._v("Philby: The Spy Who Betrayed a Generation.")])]), _vm._v(" "), _c('p', {
    staticClass: "EPI-note para-style-override-7"
  }, [_vm._v("Page, Leitch & Knightley 1968.)")]), _vm._v(" "), _c('p', {
    staticClass: "EPI para-style-override-12"
  }, [_vm._v("‘To betray, you must first belong.’")]), _vm._v(" "), _c('p', {
    staticClass: "EPI-source para-style-override-13"
  }, [_c('span', {
    staticClass: "char-style-override-18"
  }, [_vm._v("Kim Philby")])]), _vm._v(" "), _c('p', {
    staticClass: "EPI-note para-style-override-14"
  }, [_vm._v("(in an interview with Murray Sayle 1967)")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-cbff9df8","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/OldFlames_epub6.vue
// module id = 78
// module chunks = 0